'use client';

import { useEffect, useState } from 'react';
import { useProfile } from '@/src/hooks/use-profile';
import { Button } from '@workspace/ui/components/button';
import { cn } from '@workspace/ui/lib/utils';
import Link from 'next/link';

type Props = {
  isBlack?: boolean;
  isAnonymous?: boolean;
};

export const ButtonsBlock = ({ isBlack, isAnonymous }: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  return (
    <div className={isAnonymous ? '' : 'hidden'}>
      <Button
        size="sm"
        variant={isBlack ? 'secondary' : 'gray'}
        className={cn('md:px-4 px-2 text-base py-1 border-0', {
          'border border-white': isBlack,
        })}
      >
        <Link href="/sign-in" className="font-bold md:text-sm text-xs">
          Log in
        </Link>
      </Button>
      <Button size="sm" className="md:ml-2 ml-1 md:px-4 px-2 py-1">
        <Link href="/sign-up" className="font-bold md:text-sm text-xs">
          Sign up free
        </Link>
      </Button>
    </div>
  );
};

export const ButtonsBlockHome = ({ isAnonymous }: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  return (
    <div className={isAnonymous ? '' : 'hidden'}>
      <Button
        size="sm"
        variant="secondary"
        className={cn(
          'md:px-4 px-2 text-base py-1 border-0 hover:bg-black/50',
          {},
        )}
      >
        <Link href="/sign-in" className="font-bold md:text-sm text-xs">
          Log In
        </Link>
      </Button>
      <Button
        size="sm"
        className="md:ml-2 ml-1 md:px-4 px-2 py-1 bg-transparent border border-black"
      >
        <Link href="/sign-up" className="font-bold md:text-sm text-xs">
          Sign up
        </Link>
      </Button>
    </div>
  );
};

export const ButtonsBlockVertical = ({ isAnonymous }: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  return (
    <div className="flex flex-col gap-2">
      <Button size="sm" className="md:ml-2 ml-1 md:px-4 px-2 py-1 w-16">
        <Link href="/sign-up" className="font-bold md:text-sm text-xs">
          Sign up
        </Link>
      </Button>
      <Button
        size="sm"
        variant="gray"
        className={cn('md:ml-2 ml-1 md:px-4 px-2 py-1 w-14!', {})}
      >
        <Link href="/sign-in" className="font-bold md:text-sm text-xs">
          Log in
        </Link>
      </Button>
    </div>
  );
};

export const GetStartedButton = () => {
  const { data: profile, isLoading } = useProfile();
  const isAnonymous = profile?.type === 'anonymous';

  const href =
    !isLoading && !isAnonymous && profile?.uniqueLink
      ? `/${profile.uniqueLink}`
      : '/sign-up';

  const shouldPrefetch =
    !isLoading && !isAnonymous && Boolean(profile?.uniqueLink);

  return (
    <Button size="sm" className="md:ml-2 ml-0.5 md:px-4 px-3 z-[20]">
      <Link
        href={href}
        prefetch={shouldPrefetch}
        className="font-medium text-sm"
      >
        Get Started
      </Link>
    </Button>
  );
};
